// extracted by mini-css-extract-plugin
module.exports = {"button":"Button__button--2Unaz"};
    if(module.hot) {
      // 1605595229579
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  